import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image } from 'react-bootstrap';

class PropertyHours extends React.Component {
  render() {
    const hotel = this.props.hotel;
    return (
      <div className="row">
        <div className="col-md-4">
          <h4 className="hotel-highlight">Restaurant</h4>
          <p>Sunday 6:00am - 9:00pm</p>
          <p>Monday 6:00am - 9:00pm</p>
          <p>Tuesday 6:00am - 9:00pm</p>
          <p>Wednesday 6:00am - 9:00pm</p>
          <p>Thursday 6:00am - 9:00pm</p>
          <p>Friday 6:00am - 9:00pm</p>
          <p>Saturday 6:00am - 9:00pm</p>
        </div>
        <div className="col-md-4">
          <h4 className="hotel-highlight">Gym Hours</h4>
          <p>Sunday 6:00am - 9:00pm</p>
          <p>Monday 6:00am - 9:00pm</p>
          <p>Tuesday 6:00am - 9:00pm</p>
          <p>Wednesday 6:00am - 9:00pm</p>
          <p>Thursday 6:00am - 9:00pm</p>
          <p>Friday 6:00am - 9:00pm</p>
          <p>Saturday 6:00am - 9:00pm</p>
        </div>
      </div>
    );
  }
}
PropertyHours.propTypes = {
  hotel: PropTypes.object.isRequired,
};
export default PropertyHours;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyHours.js